import styled from "styled-components"

export const P = styled.p`
  color: white;
  text-align: center;
  margin-bottom: 8em;
`